import {useState, useEffect} from 'react';
import API from '../APIs/API';
import {WidgetAnalyticsPanel} from './WidgetAnalytics';
import {observer} from 'mobx-react-lite';
import Utils from '../Core/Utils';
import {ExportToCsv} from 'ts-export-to-csv';
import {Button, FormControlLabel, Radio, RadioGroup, Snackbar} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MuiAlert from '@material-ui/lab/Alert';

type Lead = {v: {source: string}};

export const WAPanel = observer(() => {
    const [loading, setLoading] = useState(true);
    const dataState = useState<Lead[]>([]);
    let data = dataState[0];
    const setData = dataState[1];
    const [optionChecked, setOptionChecked] = useState('a');
    const [selectedDate, setSelectedDate] = useState({
        startDate: new Date(new Date().getTime() - 6 * 24 * 3600 * 1000),
        endDate: new Date(),
    });
    const [showToaster, setShowToaster] = useState(false);
    const [renderMe, setRenderMe] = useState(true);
    function comparator(a: any, b: any) {
        return b.v.timestamp - a.v.timestamp;
    }
    useEffect(() => {
        (async () => {
            setLoading(true);
            setData([]);
            const msInADay = 3600 * 24 * 1000;
            let st = selectedDate.startDate.getTime(),
                end = selectedDate.endDate.getTime();
            for (let i = 0; st <= end; i++, st += msInADay) {
                let str = Utils.Date2Str(selectedDate.endDate, -i);
                str = str[8] === '0' ? str.substring(0, 8) + str.substring(9, str.length) : str;
                str = str[5] === '0' ? str.substring(0, 5) + str.substring(6, str.length) : str;
                // eslint-disable-next-line no-await-in-loop
                const data1 = await API.Call<Lead[]>(`leads/${str}`, 'GET');
                if (!data1) {
                    throw new Error('Failed to fetch leads');
                }
                for (let ind = 0; ind < data1.length; ind++) {
                    let ele = data1[ind];
                    if (ele.v.source === 'direct_traffic') {
                        data1.splice(ind, 1);
                        ind--;
                    }
                }
                data = data.concat(data1);
            }
            setData(data);
            setLoading(false);
        })();
    }, [renderMe]);
    function processData(data: any) {
        data.sort(comparator);
        let processedJsonArray: any = [];
        data.forEach((dataElement: any) => {
            let date = new Date(dataElement.v.timestamp);
            processedJsonArray.push({
                'Source/Origin': dataElement.v.source,
                'UTM-ORIGIN': dataElement.v.data === undefined ? '' : dataElement.v.data.utm_origin,
                'IP-Address': dataElement.v.ip,
                'Action/State': dataElement.v.state,
                'Activity-Time': date.toLocaleString('en-US'),
                'Client-ID': dataElement.v.client,
                'Partner-ID':
                    dataElement.v?.data?.partner_user_id === undefined ? '' : dataElement.v.data.partner_user_id,
            });
        });
        return processedJsonArray;
    }
    function generateCSV() {
        const options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title:
                optionChecked === 'a'
                    ? 'Weekly Digital Leads Report'
                    : `Digital Leads Report From ${selectedDate.endDate.getMonth()}/${selectedDate.endDate.getDate()}/${selectedDate.endDate.getFullYear()} to ${selectedDate.startDate.getMonth()}/${selectedDate.startDate.getDate()}/${selectedDate.startDate.getFullYear()}`,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            filename:
                optionChecked === 'a'
                    ? 'Weekly Digital Leads Report'
                    : `Digital Leads Report From ${selectedDate.endDate.getMonth()}/${selectedDate.endDate.getDate()}/${selectedDate.endDate.getFullYear()} to ${selectedDate.startDate.getMonth()}/${selectedDate.startDate.getDate()}/${selectedDate.startDate.getFullYear()}`,
        };
        const csvExporter = new ExportToCsv(options);
        const dataForInput = processData(data);
        csvExporter.generateCsv(dataForInput);
    }
    function handleChange(e: any) {
        setOptionChecked(e.target.value === 'past-week' ? 'a' : 'b');
    }

    function dateValidation() {
        if (selectedDate.startDate > selectedDate.endDate) {
            setShowToaster(true);
            return false;
        }
        return true;
    }
    function handleOnClose() {
        setShowToaster(false);
    }
    function handleDateChangeStart(e: any) {
        setSelectedDate({
            ...selectedDate,
            startDate: e,
        });
        dateValidation();
    }
    function handleDateChangeEnd(e: any) {
        setSelectedDate({
            ...selectedDate,
            endDate: e,
        });
        dateValidation();
    }
    function getDataFnc() {
        setData([]);
        if (optionChecked === 'a') {
            setSelectedDate({
                endDate: new Date(),
                startDate: new Date(new Date().getTime() - 7 * 24 * 3600 * 1000),
            });
            setRenderMe(!renderMe);
        } else if (dateValidation()) {
            setRenderMe(!renderMe);
        }
    }
    return (
        <div style={{width: '100%', textAlign: 'center'}}>
            {loading ? (
                <div>loading... please wait...</div>
            ) : (
                <div>
                    <WidgetAnalyticsPanel data={data}></WidgetAnalyticsPanel>
                    <Grid container justify={'space-between'} alignItems={'center'}>
                        <RadioGroup aria-label="type" name="type1">
                            <FormControlLabel
                                value="past-week"
                                control={<Radio checked={optionChecked == 'a'} onChange={handleChange} />}
                                label="Last Week"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="custom-range"
                                control={<Radio checked={optionChecked == 'b'} onChange={handleChange} />}
                                label="Custom Range"
                                labelPlacement="start"
                            />
                        </RadioGroup>
                        {optionChecked === 'a' ? null : (
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="MM/dd/yyyy"
                                    margin="normal"
                                    id="start-date"
                                    label="Start Date"
                                    value={selectedDate.startDate}
                                    onChange={handleDateChangeStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="MM/dd/yyyy"
                                    margin="normal"
                                    id="end-date"
                                    label="End Date"
                                    value={selectedDate.endDate}
                                    onChange={handleDateChangeEnd}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        )}
                        <div>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={getDataFnc}
                                style={{maxHeight: '25px', margin: '10px'}}
                            >
                                Get Data
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={generateCSV}
                                style={{maxHeight: '25px'}}
                            >
                                Download Report
                            </Button>
                        </div>
                        <Snackbar open={showToaster} autoHideDuration={3000} onClose={handleOnClose}>
                            <MuiAlert elevation={6} variant="filled" severity="error" onClose={handleOnClose}>
                                The Start date can not be smaller than the End date
                            </MuiAlert>
                        </Snackbar>
                    </Grid>
                </div>
            )}
        </div>
    );
});
